import { RequestResult } from "@hey-api/client-fetch";

const NETWORK_FETCH_ERROR_MESSAGES = new Set([
  "Failed to fetch",
  "NetworkError when attempting to fetch resource.",
  "Load failed",
]);

function getNetworkErrorMessage(error: Error): string | undefined {
  if (NETWORK_FETCH_ERROR_MESSAGES.has(error.message)) {
    return error.message;
  }

  if ("networkError" in error) {
    const networkError = (error as { networkError?: unknown }).networkError;
    if (networkError instanceof Error) {
      return networkError.message;
    }
  }

  return undefined;
}

export function isNetworkFetchError(error: Error): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return true;
  }

  const networkErrorMessage = getNetworkErrorMessage(error);
  return (
    networkErrorMessage !== undefined &&
    NETWORK_FETCH_ERROR_MESSAGES.has(networkErrorMessage)
  );
}

// TODO: This can probably be replaced by a formal type from the OpenAPI spec.
export type FormServiceError = {
  error: {
    message: string;
  };
};

export const mapFormServiceError =
  (defaultMsg: string) =>
  (error: FormServiceError | Error | null): Error => {
    return error instanceof Error
      ? error
      : new Error(error?.error?.message ?? defaultMsg);
  };

export const throwIfFormServiceError = <T>(
  result: Awaited<RequestResult<T, FormServiceError, false>>
) => {
  if (result.error)
    throw new Error(result.error.error?.message ?? "Unknown error");
  return result.data;
};
